import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guard/auth.guard';

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./features/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./features/onboarding/onboarding.module').then(m => m.OnboardingModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'create-password/:userId/:token',
    loadChildren: () =>
      import('./features/create-password/create-password.module').then(m => m.CreatePasswordModule),
  },
  {
    path: 'config',
    loadChildren: () => import('./features/config/config.module').then(m => m.ConfigModule),
    canActivate: [AuthGuard],
  },
  {
    // Portal do banco (Kit Banco): público, sem AuthGuard e fora do shell da plataforma. Sessão própria do portal.
    path: 'dataroom',
    loadChildren: () =>
      import('./features/bank-portal/bank-portal.routes').then(m => m.bankPortalRoutes),
  },
  {
    path: '',
    loadChildren: () => import('./features/login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'login',
    loadChildren: () => import('./features/login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'external',
    loadChildren: () => import('./features/external/external.module').then(m => m.ExternalModule),
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
